export const FETCH_ORDER_PACKAGES = {
    REQUEST: 'PACKAGE.ORDER_PACKAGES.FETCH_ORDER_PACKAGES.REQUEST',
    SUCCESS: 'PACKAGE.ORDER_PACKAGES.FETCH_ORDER_PACKAGES.SUCCESS',
    FAILED: 'PACKAGE.ORDER_PACKAGES.FETCH_ORDER_PACKAGES.FAILED',
};

export const CLEAR_STATE = 'PACKAGE.ORDER_PACKAGES.CLEAR_STATE';
